

















































































































import {
  computed,
  defineComponent,
  onBeforeMount,
  reactive,
  Ref,
} from '@vue/composition-api'
import moment from 'moment'

import { UserRole } from '@/types/user'
import { ChainStoreState, ItemState, UserState } from '@/types/store'
import { IUser } from '@/types/user'
import { IItem } from '@/types/receipt'
import { ItemParams } from '@/types/item'

import useVuex from '@/utils/useVuex'

import { AppAutocomplete } from '@/components/atoms'
import Layout from '@/components/organisms/common/Layout.vue'
import { ItemsTable } from '@/components/organisms/re-items'
import { ChainStoreEntity } from '../../../api/@types'

export default defineComponent({
  name: 'NewItems',
  components: { Layout, ItemsTable, AppAutocomplete },
  setup(props, context) {
    const store = context.root.$store
    const state = reactive<{
      items: Ref<IItem[]>
      total: Ref<number>
      isItemsLoading: Ref<boolean>
      chainStores: Ref<ChainStoreEntity[]>
      user: Ref<IUser | null>
      isDateOpen: boolean
      isTimeOpen: boolean
      createdAtStart: string
      createdAtStartTime: string
      createdByUserId: number | null
      updatedByUserId: number | null
      chainStoreName: string | null
      chainStoreId: number | null
    }>({
      items: useVuex<ItemState['items']>(
        context,
        () => store.getters['item/items'],
      ),
      total: useVuex<ItemState['total']>(
        context,
        () => store.getters['item/total'],
      ),
      isItemsLoading: useVuex<ItemState['isItemsLoading']>(
        context,
        () => store.getters['item/isItemsLoading'],
      ),
      chainStores: useVuex<ChainStoreState['chainStores']>(
        context,
        () => store.getters['chainStore/chainStores'],
      ),
      user: useVuex<UserState['user']>(
        context,
        () => store.getters['user/user'],
      ),
      isDateOpen: false,
      isTimeOpen: false,
      createdAtStart: moment().format('YYYY-MM-DD'),
      createdAtStartTime: moment().format('HH:00'),
      createdByUserId: null,
      updatedByUserId: null,
      chainStoreName: null,
      chainStoreId: null,
    })

    const generateParams = computed<ItemParams>(() => {
      return {
        isMatched: true,
        createdAtStart: moment(
          `${state.createdAtStart} ${state.createdAtStartTime}:00`,
        ).toDate(),
        createdByUserId: state.createdByUserId,
        updatedByUserId: state.updatedByUserId,
        chainStoreId: state.chainStoreId,
      }
    })

    const onSelectChainStore = (cs?: ChainStoreEntity) => {
      if (cs === undefined) {
        state.chainStoreName = null
        state.chainStoreId = null
        return
      }
      state.chainStoreName = cs.name
      state.chainStoreId = cs.id
    }

    const search = async () => {
      try {
        await store.dispatch('item/getNewItems', generateParams.value)
      } catch (_) {
        await store.dispatch('item/resetItems')
        alert('タイムアウトしました。検索条件を変更して再度お試しください。')
      }
    }

    onBeforeMount(() => {
      store.dispatch('item/resetItems')
    })

    return { state, UserRole, onSelectChainStore, search }
  },
})
